import React from "react";
import Page from "../../common/page/Page.js";
import CandidatesBlock from "./CandidatesBlock.js";
import useQueryJobById from "../../jobs/view/useQueryJobById.js";
import { useParams } from "react-router";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";


export default function CandidatesPage(props) {

  // Fetch job from ID provided in the url params.
  const urlParams = useParams();
  const jobId = urlParams.jobId;
  const statusFilter = props && props.location && props.location.state && props.location.state.status;
  const {
    data: job,
    loading: jobLoading,
    errors: jobErrors,
  } = useQueryJobById(jobId);

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <WaitForData
          loading={jobLoading}
          errors={jobErrors}
          onLoaded={() => (
            <Page className="CandidatesPage">
              <Page.Title
                text={job.title}
                loading={jobLoading}
              />
              <Page.Content>
                <CandidatesBlock statusFilter={statusFilter} job={job} />
              </Page.Content>
            </Page>
          )}
        />
      )}
    />
  );
}
